
export interface IShortCodeState {
    ShortCode: string[];
}